import Slider, { type Settings } from 'react-slick'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import Bottle from '../../assets/images/bottle.png'
import EClass from '../../assets/images/fleet-e-class.png'
import Economy from '../../assets/images/fleet-saloon-car.png'
import SClass from '../../assets/images/fleet-s-class.png'
import Passenger from '../../assets/images/user.svg'
import VClass from '../../assets/images/fleet-v-class.png'
import Wifi from '../../assets/images/wifi.png'
import style from './Fleet2.module.scss'

const settings: Settings = {
  dots: true,
  arrows: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
  className: style.wedo__slider__overrides,
}

const FleetV2 = () => {
  return (
    <div className={style.wedo}>
      <h2>Our Fleet</h2>
      <div className="container">
        <div className={style.wedo__slider}>
          <Slider {...settings}>
            {/*  */}
            {/* ECONOMY */}
            <div className={style.wedo__item}>
              <div className={style.wedo__card}>
                <div>
                  <picture>
                    <img src={Economy} alt="airport_shuttle" />
                  </picture>

                  <strong>Economy Class</strong>
                </div>
                <div className={style.wedo__card__content}>
                  <span>4 passengers</span>
                  <span>Free Wifi</span>
                  <span>Free water</span>
                  {/* <span>Book Hourly (Min 3hrs)</span> */}
                  {/* <span>Book by Day (8hrs)</span> */}
                  <span>Fits 2 large suitcases & 2 carry-ons</span>
                </div>
                {/* <div className={style.wedo__card__addons}>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Passenger} alt="passenger" />
                    <p>4 Passengers</p>
                  </div>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Wifi} alt="wifi" />
                    <p>Free Wifi</p>
                  </div>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Bottle} alt="bottle" />
                    <p>Free water</p>
                  </div>
                </div> */}
              </div>
            </div>

            {/* Mercedes E-Class */}

            <div className={style.wedo__item}>
              <div className={style.wedo__card}>
                <div>
                  <picture>
                    <img src={EClass} alt="airport_shuttle" />
                  </picture>
                  <strong>Mercedes E-Class</strong>
                </div>
                <div className={style.wedo__card__content}>
                  <span>4 passengers</span>
                  <span>Free Wifi</span>
                  <span>Free water</span>
                  {/* <span>Book Hourly (Min 3hrs)</span> */}
                  {/* <span>Book by Day (8hrs)</span> */}
                  <span>Fits 2 large suitcases & 2 carry-ons</span>
                </div>
                {/* <div className={style.wedo__card__addons}>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Passenger} alt="passenger" />
                    <p>3 Passengers</p>
                  </div>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Wifi} alt="wifi" />
                    <p>Free Wifi</p>
                  </div>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Bottle} alt="bottle" />
                    <p>Free water</p>
                  </div>
                </div> */}

                {/* <div className={style.wedo__card__addons}>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Passenger} alt="passenger" />
                    <p>3 Passengers</p>
                  </div>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Wifi} alt="wifi" />
                    <p>Free Wifi</p>
                  </div>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Bottle} alt="bottle" />
                    <p>Free water</p>
                  </div>
                </div> */}
              </div>
            </div>

            {/* Mercedes V-Class */}

            <div className={style.wedo__item}>
              <div className={style.wedo__card}>
                <div>
                  <picture>
                    <img src={VClass} alt="airport_shuttle" />
                  </picture>
                  <strong>Mercedes V-Class</strong>
                </div>
                <div className={style.wedo__card__content}>
                  <span>6 passengers</span>
                  <span>Free Wifi</span>
                  <span>Free water</span>
                  {/* <span>Book Hourly (Min 3hrs)</span> */}
                  {/* <span>Book by Day (8hrs)</span> */}
                  <span>Fits 5 large suitcases & 2 carry-ons</span>
                </div>
                {/* <div className={style.wedo__card__addons}>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Passenger} alt="passenger" />
                    <p>6 Passengers</p>
                  </div>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Wifi} alt="wifi" />
                    <p>Free Wifi</p>
                  </div>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Bottle} alt="bottle" />
                    <p>Free water</p>
                  </div>
                </div> */}
              </div>
            </div>

            {/* Mercedes S-Class */}

            <div className={style.wedo__item}>
              <div className={style.wedo__card}>
                <div>
                  <picture>
                    <img src={SClass} alt="airport_shuttle" />
                  </picture>
                  <strong>Mercedes S-Class</strong>
                </div>
                <div className={style.wedo__card__content}>
                  <span>3 passengers</span>
                  <span>Free Wifi</span>
                  <span>Free water</span>
                  {/* <span>Book Hourly (Min 3hrs)</span> */}
                  {/* <span>Book by Day (8hrs)</span> */}
                  <span>Fits 2 large suitcases & 2 carry-ons</span>
                </div>

                {/* <div className={style.wedo__card__addons}>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Passenger} alt="passenger" />
                    <p>3 Passengers</p>
                  </div>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Wifi} alt="wifi" />
                    <p>Free Wifi</p>
                  </div>
                  <div className={style.wedo__card__addons__item}>
                    <img src={Bottle} alt="passenger" />
                    <p>Free water</p>
                  </div>
                </div> */}
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </div>
  )
}
export default FleetV2
